module.exports = __webpack_public_path__ + "static/media/web.91755d95.png";